import { Box, Grid, Typography} from "@mui/material"
import moment from "moment"
import { Waypoint } from "react-waypoint"
import { SnakeLoader } from "../../../../../../core/loader/SnakeLoader"
import { ThreeDots } from "../modal/ThreeDots";

export const TBody = ({ concernData, handleView, infntScroll, loadMoreData, handleOpen,}) => {

    return (
        <Box height="100%" width="100%" gap="12px" className="overflowY" display="flex" flexDirection="column" p="10px 0px 10px 0px">
            {
                concernData.data.map((v,k) => (
                <Box key={k} width="100%" height='auto'fontWeight={400} display="block"  border="1px solid #EBEBEB" bgcolor="#FFFFFF" p='15px 0px 8px 20px'>
                    
                    <Grid container   display="flex" justifyContent="space-between" >
                        <Grid item xs={10} onClick={(e) =>{ e.stopPropagation(); handleView ('view', v.id)}}>
                            <Box display={'row'} justifyContent={'space-between'}  >
                                <Box sx={{display:'flex', justifyContent:'space-between'}}>
                                        <Typography sx={{ fontSize:'12px'}} fontWeight={600}>Category:</Typography>
                                        <Typography sx={{ fontSize:'12px',textAlign:'right',pl:'30px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.speakout_category}</Typography>
                                </Box>

                                <Box sx={{display:'flex', justifyContent:'space-between'}} >
                                    <Typography  sx={{height:'auto', fontSize:'12px'}}  fontWeight={600}>Receiver:</Typography>
                                    <Typography sx={{height:'auto', fontSize:'12px',textAlign:'right'}}>{v.speakout_team}</Typography>
                                </Box>

                                <Box sx={{display:'flex', justifyContent:'space-between'}}>
                                            <Typography sx={{height:'auto', fontSize:'12px',textAlign:'left',  whiteSpace: 'nowrap', overflow: 'show' }} fontWeight={600}>Type of Concern:</Typography>
                                            <Typography sx={{ fontSize:'12px',textAlign:'right',pl:'30px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.type === 1 ? 'Suggestion/Recommendation' : 'Concern'}</Typography>
                                </Box>

                                <Box sx={{display:'flex', justifyContent:'space-between'}}>
                                    <Typography sx={{ fontSize:'12px'}} fontWeight={600}>Date:</Typography>
                                    <Box sx={{height:'auto', fontSize:'12px',textAlign:'right'}}>{moment(v.created_at).format("MMM DD,YYYY")}</Box>
                                </Box>

                                <Box  sx={{display:'flex', justifyContent:'space-between'}}>
                                    <Typography sx={{height:'auto', fontSize:'12px'}} fontWeight={600}>Status:</Typography>
                                    <Box sx={{ fontSize:'12px',}} display="flex" alignItems="center" textAlign="center" justifyContent="center" bgcolor={v.status === 1 ? '#00be811f' : '#E4E5E6'} color={v.status === 1 ? '#00be81' : '#7B7F82'} borderRadius="16px" width="100px">
                                        <Box>{v.status === 1 ? 'Received' : 'Done'}</Box>
                                    </Box>
                                </Box>
                        
                            </Box>
                        </Grid>
                        <Grid item xs={2}>
                            <Box display='flex' justifyContent="center" alignItems='center' height='100%'>
                                <ThreeDots handleView={handleView} v={v} handleOpen={handleOpen} concernData={concernData} />
                                
                            </Box>
                            
                        </Grid>
                    </Grid>

                </Box>

                ))
            }
            {
                infntScroll.data && (
                    <Box display="flex" justifyContent="center">
                        <Waypoint onEnter={loadMoreData} >
                            <Box component="strong" mt={5} display="flex" justifyContent="center">
                                <SnakeLoader size="10px" bg="#11783C" distance="0.3rem" />
                            </Box>
                        </Waypoint>
                    </Box>
                )
            }
        </Box>
    )
}